module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-116.989ebf85.svg";